export default __webpack_public_path__ + "static/media/BR.f9446257.svg";